import { DataBean } from "../DataBean";


export class DispatchMethodTypeConstants extends DataBean {
    public async getDispatchMethodTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDispatchMethodTypeConstants_Number", [args]);
    }


}